// source: PublicBookTickerBatchV3Api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var PublicBookTickerV3Api_pb = require('./PublicBookTickerV3Api_pb.js');
goog.object.extend(proto, PublicBookTickerV3Api_pb);
goog.exportSymbol('proto.PublicBookTickerBatchV3Api', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PublicBookTickerBatchV3Api = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.PublicBookTickerBatchV3Api.repeatedFields_, null);
};
goog.inherits(proto.PublicBookTickerBatchV3Api, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PublicBookTickerBatchV3Api.displayName = 'proto.PublicBookTickerBatchV3Api';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.PublicBookTickerBatchV3Api.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PublicBookTickerBatchV3Api.prototype.toObject = function(opt_includeInstance) {
  return proto.PublicBookTickerBatchV3Api.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PublicBookTickerBatchV3Api} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicBookTickerBatchV3Api.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    PublicBookTickerV3Api_pb.PublicBookTickerV3Api.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PublicBookTickerBatchV3Api}
 */
proto.PublicBookTickerBatchV3Api.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PublicBookTickerBatchV3Api;
  return proto.PublicBookTickerBatchV3Api.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PublicBookTickerBatchV3Api} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PublicBookTickerBatchV3Api}
 */
proto.PublicBookTickerBatchV3Api.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new PublicBookTickerV3Api_pb.PublicBookTickerV3Api;
      reader.readMessage(value,PublicBookTickerV3Api_pb.PublicBookTickerV3Api.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PublicBookTickerBatchV3Api.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PublicBookTickerBatchV3Api.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PublicBookTickerBatchV3Api} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicBookTickerBatchV3Api.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      PublicBookTickerV3Api_pb.PublicBookTickerV3Api.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PublicBookTickerV3Api items = 1;
 * @return {!Array<!proto.PublicBookTickerV3Api>}
 */
proto.PublicBookTickerBatchV3Api.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.PublicBookTickerV3Api>} */ (
    jspb.Message.getRepeatedWrapperField(this, PublicBookTickerV3Api_pb.PublicBookTickerV3Api, 1));
};


/**
 * @param {!Array<!proto.PublicBookTickerV3Api>} value
 * @return {!proto.PublicBookTickerBatchV3Api} returns this
*/
proto.PublicBookTickerBatchV3Api.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.PublicBookTickerV3Api=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PublicBookTickerV3Api}
 */
proto.PublicBookTickerBatchV3Api.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.PublicBookTickerV3Api, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.PublicBookTickerBatchV3Api} returns this
 */
proto.PublicBookTickerBatchV3Api.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


goog.object.extend(exports, proto);
